import { render, staticRenderFns } from "./Xiuhua.vue?vue&type=template&id=2f4948bd&scoped=true"
import script from "./Xiuhua.vue?vue&type=script&lang=js"
export * from "./Xiuhua.vue?vue&type=script&lang=js"
import style0 from "./Xiuhua.vue?vue&type=style&index=0&id=2f4948bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4948bd",
  null
  
)

export default component.exports